/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetQuestionAnswersRequest,
  TGetQuestionAnswersModel,
  IMappers,
  TGetQuestionAnswersResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetQuestionAnswersResponse } from '../../entities/get_question_answers/GetQuestionAnswersResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetQuestionAnswersModel(parameters: TGetQuestionAnswersRequest): TGetQuestionAnswersModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-reviews',
    pathApi: '/v1/get-question-answers/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetQuestionAnswersOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetQuestionAnswersRequest;
}

export async function fetchGetQuestionAnswers<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetQuestionAnswersOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetQuestionAnswersResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetQuestionAnswersModel(parameters),
    config,
  )) as FetchResponse<TGetQuestionAnswersResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetQuestionAnswersResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetQuestionAnswersResponse>;
}
